import { BuildingOfficeOrderSiteMenuList } from "../../utils/constants";
import { TableStructure } from "../../components/TableStructure";

const List = [
  {
    fileStoreId: "69ae3537-b54f-4982-87eb-0cb6c0e79155",
    label: "DG(BLDG)'s Office Order No. 5 of 2014-2015",
    date: "17/03/2015",
    subject: "Thika post sanction wiil be looked after by Borough",
  },
  {
    fileStoreId: "4839d4fd-1f0c-4de2-a696-3ed14e97c1d8",
    label: "DG(BLDG)'s Office Order No. 4 of 2014-2015",
    date: "11/10/2014",
    subject: "Sanction of petrol pump",
  },
  {
    fileStoreId: "a1fb22e6-547f-44ca-b5d0-5c2418d96972",
    label: "DG(BLDG)'s Office Order No. 2 of 2014-2015",
    date: "09/07/2014",
    subject: "Mosquito prevention guideline",
  },
];

const Building_OfficeOreder_2014 = () => (
  <TableStructure
    title="Office Order/ 2014"
    heading={false}
    list={List}
    columnNo={3}
    firstColumnName="Office Order No"
    leftMenuList={BuildingOfficeOrderSiteMenuList}
    longMenuList={true}
  />
);

export default Building_OfficeOreder_2014;
